export const COMPENSATORY_CONTROL_NATURE_TEMPORARY = 'temporary';
export const COMPENSATORY_CONTROL_NATURE_PERMANENT = 'permanent';

export const COMPENSATORY_CONTROL_NATURES = [
    COMPENSATORY_CONTROL_NATURE_TEMPORARY,
    COMPENSATORY_CONTROL_NATURE_PERMANENT,
];
